import React, { Component } from "react";
import axios from "axios";
import Router from "next/router";
import { SearchFeild, InText } from "../components";
import Layout from "../container";
import { LandingGrids, LandingFooter } from "../pagecomponents/Welcome";
import { gridData } from "../pagecomponents/Welcome/landingData.json";
import {
  Divider,
  Segment,
  Grid,
  Container,
  Tab,
  Input,
  Icon,
} from "semantic-ui-react";
import PlacesAutocomplete from "react-places-autocomplete";
import Head from "next/head";
import cookie from "react-cookies";
import { getSearchNeighbors } from "../modules/Graphql/neighboraddressserachgraphql";
import { GridPDFExport } from "@progress/kendo-react-pdf";
var localStorage = require("localStorage");
class LandingPage extends Component {
  constructor() {
    super();
    this.resultarr = [];

    this.state = {
      places: [],
      address: "",
      query: "",
      results: [],
      loadingtext: "hidden",
      resindex: 5,
      displaydata: "hidden",
      activeSuggestion: 0,
      userInput: "",
      showSuggestions: false,
      address: "",
      newsuggestion_length: "",
      gmapsLoaded: false,
      first_record: true,
    };

    this.initMapdata = this.initMapdata.bind(this);
  }
  newsuggestion_length = 0;
  newsuggestions = [];

  initMapdata = () => {
    this.setState({
      gmapsLoaded: true,
    });
  };
  componentDidMount() {
    let getcredentialchange = localStorage.getItem("credentialchange");
    if (getcredentialchange === "true") {
      setTimeout(() => {
        if (
          document.getElementById("sign_in_btn") &&
          document.getElementById("sign_in_btn") !== undefined
        ) {
          document.getElementById("sign_in_btn").click();
          localStorage.setItem("credentialchange", "");
        }
      }, 5000);
    }
    setTimeout(() => this.initMapdata(), 2000);
  }
  getInfo = () => {
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "label",
      order: "ASC",
      fields: [
        {
          name: "label",
          value: this.state.query,
          operator: "LIKE",
        },
      ],
    };

    getSearchNeighbors(getdata)
      .then((result) => {
        if (result.data.getSearchNeighbors.length === 0) {
          this.setState({ loading: "none" });
        }
        if (result.data.getSearchNeighbors.length > 0)
          this.setState({ loading: "none" });
        this.setState({ showSuggestions: true });

        this.setState({
          results: result.data.getSearchNeighbors,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  handleSignupClick = () => {
    if (
      document.getElementById("sign_up_btn") &&
      document.getElementById("sign_up_btn") != undefined
    ) {
      document.getElementById("sign_up_btn").click();
    } else {
      window.location.href = `/?address=San Francisco, CA, USA`;
    }
  };
  handleInputChange = (address) => {
    this.setState({ userInput: address });
    let searchquery = this.search.value;
    let searchdata = searchquery.replace(/[' ']/g, "%");

    this.setState({ address: address });

    this.setState(
      {
        query: searchquery,
      },
      () => {
        if (this.state.query && this.state.query.length > 2) {
          this.setState({ loading: "block" });
          this.getInfo();
        }

        if (this.state.query.length === 0) {
          this.setState({
            results: [],
          });
          this.setState({ showSuggestions: false });
        }
      }
    );
  };

  handleKeyChange = (e) => {
    this.setState({ first_record: true });
    const { activeSuggestion, results } = this.state;

    if (results.length > 0) {
      if (e.keyCode === 13) {
        this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          userInput: results[activeSuggestion].label,
        });
        let red_address = results[activeSuggestion].label;
        localStorage.setItem("ispagemain", true);
        window.location.replace("/?address=" + red_address);
      }

      // User pressed the up arrow, decrement the index
      else if (e.keyCode === 38) {
        if (this.state.activeSuggestion === 0) {
          return;
        }

        if (activeSuggestion === 0 && this.state.first_record) {
          this.setState({ userInput: results[activeSuggestion].label });
          this.setState({ first_record: false });
        } else {
          this.setState({ activeSuggestion: activeSuggestion - 1 });
          this.setState({ userInput: results[activeSuggestion - 1].label });
        }
      }

      // User pressed the down arrow, increment the index
      else if (e.keyCode === 40) {
        if (this.state.activeSuggestion + 1 === this.newsuggestion_length) {
          return;
        } else {
          if (activeSuggestion === 0 && this.state.first_record) {
            this.setState({ userInput: results[activeSuggestion].label });
            this.setState({ first_record: false });
          } else {
            this.setState({ activeSuggestion: activeSuggestion + 1 });
            this.setState({ userInput: results[activeSuggestion + 1].label });
          }
        }
      }
    }
  };

  handleSelect = (e) => {
    this.setState({ userInput: e.currentTarget.innerText });
    let red_address = e.currentTarget.innerText;
    localStorage.setItem("ispagemain", true);
    window.location.replace("/?address=" + red_address);
  };

  handleOutsideClick = () => {
    if (this.state.showSuggestions === true) {
      this.setState({ showSuggestions: false });
    }
  };

  render() {
    let { places } = this.state;
    let loaderdisplay;
    if (this.state.loadingtext === "visible") {
      loaderdisplay = "block";
    } else {
      loaderdisplay = "none";
    }
    const searchOptions = {
      types: ["(regions)"],
    };
    const onError = (status, clearSuggestions) => {};
    let dataarr = [];
    const unique = [];
    let result = [];
    return (
      <div className="state-agents-wrapper home-wrapper">
        <Head>
          <title>Houseberry For Real Estate Agents</title>
          <meta
            name="description"
            content="Houseberry supports Real Estate Agents! Review neighborhoods you know best and answer questions to become a Featured Top Agent. Share Houseberry with your clients to provide neighborhood insights and listings exposure."
          ></meta>
          <meta
            name="keywords"
            content="Real Estate Agents, Neighborhood Data, Client Resources, Home Listings"
          ></meta>
        </Head>
        {this.state.gmapsLoaded && (
          <Layout tagline>
            <Segment
              basic
              onClick={this.handleOutsideClick}
              style={{ paddingTop: 5, margin: 0 }}
              className="state-agents"
            >
              {/* <InText size="large" name="Find your dream Neighborhood" color="blue"/>
          <Divider hidden/>
          <Divider hidden/> */}
              <Grid>
                <Grid.Row style={{ padding: 0 }}>
                  <Grid.Column
                    mobile={16}
                    tablet={16}
                    computer={16}
                    style={{ padding: 0 }}
                  >
                    <div
                      className="welcome_banner_agent"
                      style={{
                        backgroundImage:
                          "url('/static/images/hb_banner_new1.png')",
                      }}
                    >
                      {/* <img src="/static/images/hb_welcome.png"/> */}
                      <div className="welcome_top_main_agent">
                        <div className="agent_top_containt">
                          <div className="agent_top_title">
                            {/* <h2>Hello Real Estate Agents</h2> */}
                            <p>
                              No need to pay for leads - Houseberry is FREE for
                              agents.
                            </p>
                          </div>
                          <div className="agent_tag_lines">
                            <p>
                              Clients should choose an agent who knows their
                              area best - not who has the highest ad budget.
                            </p>
                            <p>
                              On Houseberry, agents attract clients by
                              showcasing their expertise.
                            </p>
                          </div>
                          <div className="agent_middle_txt">
                            <div className="middle_first">
                              <p>
                                <img
                                  src="/static/images/agents/Search.png"
                                  title="serach neighborhood"
                                  alt="search"
                                />
                                <span className="numbers">1)</span>Find
                                Neighborhoods that you know well.
                              </p>
                            </div>
                            <div className="middle_sec">
                              <p>
                                <img
                                  src="/static/images/agents/Review.png"
                                  alt="Review Neighbirhood"
                                  title="review neighborhood"
                                />
                                <span className="numbers">2)</span>Become a "Top
                                Agent" in the areas you know best by writing a
                                helpful review of the neighborhood or answering
                                questions.
                              </p>
                            </div>
                            {/* <div className="middle_third">
                              <p>
                                <img src="/static/images/agents/Top_Prize.png" />
                                <span className="numbers">3)</span>Get contacted
                                directly by buyers and sellers. Use your
                                Houseberry Top Agent status for marketing.
                              </p>
                            </div> */}
                            <div className="middle_fourth">
                              <p>
                                <img
                                  src="/static/images/agents/Handshake.png"
                                  alt="connected by buyer and seller"
                                  title="contact"
                                />
                                <span className="numbers">3)</span>Get contacted
                                by Buyers and Sellers.
                                <br />
                                Use your Houseberry profile for marketing.
                              </p>
                            </div>
                          </div>
                          <div className="welcome_serach_agent_signup">
                            <button
                              type="button"
                              onClick={this.handleSignupClick}
                            >
                              Sign Up Now
                            </button>
                            <div>
                              <a
                                href="/?address=San Francisco, CA, USA"
                                title="Explore Houseberry First"
                              >
                                Explore Houseberry First
                              </a>
                            </div>
                          </div>

                          {/* <div className="welcome_text">
                <h1>We help you find the house of your dream.</h1>
            </div> */}
                        </div>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
            <Divider hidden />
            <Divider hidden />
            <LandingFooter />
          </Layout>
        )}
      </div>
    );
  }
}

export default LandingPage;
